import React from 'react';
import PropTypes from 'prop-types';

export default function DealLink({ deal, name }) {
  if (!deal?.path) {
    return null;
  }

  return <a href={deal.path}>{deal[name]}</a>;
}

DealLink.propTypes = {
  deal: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,
  name: PropTypes.string.isRequired,
};
